import Axios from "axios";

import { SET_LEAVE_LIST, UNSET_LEAVE_LIST } from "@/store/mutation-types";


import {
  leaveApplicationList as leaveApplicationListApi,
  saveUpdateLeaveApplication as saveUpdateLeaveApi,
} from "@/store/api";

const state = {
  getLeaveList: [],
  editingLeave: null,
};


const getters = {
  getLeaveList(state) {
    return state.getLeaveList;
  },
  editingLeave: (state) => state.editingLeave,
};



// Mutations
const mutations = {
  [SET_LEAVE_LIST](state, data) {
    state.getLeaveList = data;
  },
  [UNSET_LEAVE_LIST](state) {
     state.getLeaveList = [];
  },
  editingLeave(state, leave) {
    state.editingLeave = leave;
  },
};


// Actions
const actions = {
  saveUpdateLeave({ commit }, data) {
      commit("SET_LOADING", {color: "primary"});
      return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLeaveApi, data)
          .then(function (response) {
              resolve(response);
          })
          .catch(function (error) {
          reject(error);
          })
          .then((always) => {
              commit("UNSET_LOADING");
          });
      });
  },

  getLeaveList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${leaveApplicationListApi}`, { params: data })
        .then((response) => {
          commit(SET_LEAVE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_LEAVE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};


export default {
  state,
  getters,
  actions,
  mutations,
};